// F8 / CAMILLE (2026-10-31): A PLACE RESOLVED IN ONE COUNTRY DOES NOT SURVIVE A CHANGE OF COUNTRY.
//
// Camille was born in San Fernando, Trinidad and Tobago. Her row held San Fernando, CALIFORNIA (34.285, -118.438,
// region California) with her country set to Trinidad and Tobago: the city was picked while the country box was
// empty (the picker fills the country it found), and changing the country afterwards left the California city,
// region and coordinates behind. A filled city is never searched again, so every save kept them, and her chart was
// cast for the wrong side of the world. She saw it as "it keeps reverting after I save it".
//
// The rule: when the country really moves (both ends are a known country, and they differ) and a place is resolved,
// the resolution is cleared. The city TEXT stays, so she picks it again from the list in the new country; the field
// already asks for that pick when a city has no coordinates. Typing through the country box (codes unknown on the
// way) clears nothing, and re-typing the same country clears nothing.
//
// Pure, and imports nothing, so a gate can run it (src/lib's entry rule).
export const COUNTRY_CHANGE_CLEARS = { birthRegion: "", latitude: "", longitude: "", timezone: "", timezoneName: "" } as const;

export function countryChangePatch({ prevCode, nextCode, hasCoordinates }: {
  prevCode: string;
  nextCode: string;
  hasCoordinates: boolean;
}): Partial<typeof COUNTRY_CHANGE_CLEARS> {
  const a = String(prevCode || "").trim().toUpperCase();
  const b = String(nextCode || "").trim().toUpperCase();
  if (!hasCoordinates || !a || !b || a === b) return {};
  return { ...COUNTRY_CHANGE_CLEARS };
}
